import { Amplify } from 'aws-amplify';
import { createRoot } from 'react-dom/client';

import App from '@/app/app';
import awsConfig from '@/app/aws-config';
import { tryRecoverFromChunkError } from '@/components/error-handling/hooks/use-chunk-error-recovery';
import { handleDomainRedirect } from '@/lib/navigation/domain-redirect';
import '@/styles/App.css';

// Domain redirect - must run before anything else
handleDomainRedirect();

Amplify.configure(awsConfig);

// Recharts performance patches are applied lazily via
// `ensureChartPatches()` when the first chart chunk loads
// (see `components/data-visualization/charts/lazy-charts.tsx`).

window.addEventListener('error', event => {
  tryRecoverFromChunkError(event.message ?? event.error);
});

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App />);
